import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import floodWarning from "../../Assets/Projects/floodWarning.webp";
import maze from "../../Assets/Projects/maze.png";
import movieLibrary from "../../Assets/Projects/movieLibrary.jpg";
import bookLibrary from "../../Assets/Projects/bookLibrary.jpeg";
import cclmagic from "../../Assets/Projects/CCL Magic.png";

function Projects() {
	return (
		<Container fluid className="project-section">
			<Particle />
			<Container>
				<h1 className="project-heading">
					My Recent <strong className="purple">Works </strong>
				</h1>
				<p style={{ color: "white" }}>
					Here are a few projects I've worked on recently.
				</p>

				<Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
					<Col md={4} className="project-card">
						<ProjectCard
							imgPath={floodWarning}
							isBlog={false}
							title="Breakfast Creek Flood Warning"
							description="Developed a flood prediction machine learning algorithm by creating a website with HTML, CSS/Bootstrap, JavaScript/React for the front-end. Implemented the backend using NodeJS templates for rendering dynamic content. Utilised Databricks for efficient database management, and achieved a 93% accuracy for the machine learning model."
							demoLink="https://www.breakfastcreek.xyz/prototype"
						/>
					</Col>

					{/* <Col md={4} className="project-card">
						<ProjectCard
							imgPath={bitsOfCode}
							isBlog={true}
							title="Bits-0f-C0de"
							description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
							// ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
							demoLink="https://blogs.soumya-jit.tech/"
						/>
					</Col> */}

					<Col md={4} className="project-card">
						<ProjectCard
							imgPath={movieLibrary}
							isBlog={false}
							title="Movie Library"
							description="Developed a movie library console booking app, producing a detailed system design with class diagrams. Implemented reusable Abstract Data Types (ADTs) in a C# interface and utilized data structures and algorithms for efficient data manipulation."
							ghLink="https://github.com/panhduc1001/Movie-Library"
						/>
					</Col>

					<Col md={4} className="project-card">
						<ProjectCard
							imgPath={bookLibrary}
							isBlog={false}
							title="Book Library Website"
							description="Developed a book library wesbite using React and webAPI from Udemy. The website allows users to search for books, add books to their reading list, and leave reviews."
							demoLink="https://jacksonreadinglibrary.netlify.app/"
						/>
					</Col>

					<Col md={4} className="project-card">
						<ProjectCard
							imgPath={maze}
							isBlog={false}
							title="Maze Game"
							description="Produced a detailed system design with class diagrams based on user stories. Implemented comprehensive unit testing to ensure bug-free program execution. Demonstrated the system to the client via video to verify requirements. Technical skills include Java with JDBC (MySQL, PostgreSQL), and AdoptOpenJDK."
							ghLink="https://github.com/panhduc1001/Maze-Game"
						/>
					</Col>

					<Col md={4} className="project-card">
						<ProjectCard
							imgPath={cclmagic}
							isBlog={false}
							title="CCL Magic"
							description="Created an interactive front-end using HTML, CSS, and ReactJS, while implementing the back-end with NodeJS and REST API for server communication. Utilised MongoDB for efficient database management, ensuring seamless data retrieval and storage. Achieved a responsive and user-friendly interface with Bootstrap components. Technical skills include HTML, CSS, ReactJS, NodeJS, REST API, MongoDB, AWS (App Runner & Amplify), Jira, and Confluence."
							// ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
							demoLink="https://cclmagic.com.au/"
						/>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}

export default Projects;
